import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=10090e6a&"
import script from "./MainTabs.vue?vue&type=script&lang=ts&"
export * from "./MainTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports